/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check WCAG colour contrast between text and background.`)
};

const es_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de casos gratuito. Transforma instantáneamente texto a UPPERCASE, lowercase, Title Case, camelCase, snake_case, kebab-case y más. Copia cualquier resultado.`)
};

const de_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Case Converter. Konvertiere Text sofort in UPPERCASE, lowercase, Title Case, camelCase, snake_case, kebab-case und mehr. Kopiere jedes Ergebnis.`)
};

const nl_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis zaakconverter. Zet tekst onmiddellijk om naar HOOFDLETTERS, kleine letters, Titeltekst, camelCase, snake_case, kebab-case en meer. Kopieer elk resultaat.`)
};

const fr_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de casse gratuit. Transformez instantanément le texte en UPPERCASE, lowercase, Title Case, camelCase, snake_case, kebab-case et bien d'autres. Copiez n'importe quel résultat.`)
};

const it_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di case gratuito. Trasforma istantaneamente il testo in UPPERCASE, lowercase, Title Case, camelCase, snake_case, kebab-case e altro. Copia qualsiasi risultato.`)
};

const pt_br2_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de caso gratuito. Transforme instantaneamente o texto para UPPERCASE, lowercase, Title Case, camelCase, snake_case, kebab-case e mais. Copie qualquer resultado.`)
};

const pt_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de casos gratuito. Transforme instantaneamente o texto para MAIÚSCULAS, minúsculas, Caso de Título, camelCase, snake_case, kebab-case e mais. Copie qualquer resultado.`)
};

const ja_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のケースコンバーター。テキストをUPPERCASE、lowercase、Title Case、camelCase、PascalCase、snake_case、kebab-caseなどに瞬時に変換できます。任意の結果をコピーしてください。`)
};

const zh_cc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的大小写转换工具。立即将文本转换为 UPPERCASE、lowercase、Title Case、camelCase、snake_case、kebab-case 等格式。可复制任意结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_tool_description", locale)
	if (locale === "en") return en_cc_tool_description(inputs)
	if (locale === "es") return es_cc_tool_description(inputs)
	if (locale === "de") return de_cc_tool_description(inputs)
	if (locale === "nl") return nl_cc_tool_description(inputs)
	if (locale === "fr") return fr_cc_tool_description(inputs)
	if (locale === "it") return it_cc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cc_tool_description(inputs)
	if (locale === "pt") return pt_cc_tool_description(inputs)
	if (locale === "ja") return ja_cc_tool_description(inputs)
	return zh_cc_tool_description(inputs)
};